/**
 * Absolute URL for a payment gateway to send the customer back to, resolved
 * against the document `<base href>` (`/` on staging, `/myceremony/` in
 * production) so it always lands back in this app.
 */
export function buildReturnUrl(
  appPath: string,
  baseHref: string = readBaseHref(),
  origin: string = window.location.origin,
): string {
  let base = baseHref || '/';
  if (/^https?:\/\//i.test(base)) {
    base = new URL(base).pathname;
  }
  if (!base.startsWith('/')) base = `/${base}`;
  if (!base.endsWith('/')) base = `${base}/`;
  return `${origin}${base}${appPath.replace(/^\/+/, '')}`;
}

export function readBaseHref(): string {
  return document.querySelector('base')?.getAttribute('href') || '/';
}
